export const translations = {
  fr: {
    // Header
    home: 'ACCUEIL',
    discoverTeam: 'DÉCOUVREZ GLOBAL CONSTRUCTION',
    aboutUs: 'QUI SOMMES-NOUS ?',
    news: 'ACTUALITÉS',
    yourProject: 'VOTRE PROJET',
    publications: 'PUBLICATIONS',

    // Top Bar
    topBarTagline: 'Construction & Ingénierie en République Démocratique du Congo',
    topBarContactExperts: 'Contactez nos experts',
    topBarJobs: 'Offres d\'emploi',
    
    // Company Info
    companyName: 'GLOBAL CONSTRUCTION & INGEGNERIE SARL',
    motto: '« L\'excellence est ma loi »',
    description: 'Service public de la RD Congo avec pour mission la conception et le management des projets d\'infrastructures structurantes dans les secteurs de Routes, Voiries, Ports, Aéroports, Chemins de fer, Architecture, Énergies, Infrastructures passives de télécommunication et Environnement.',
    ambition: 'Ambition de devenir un grand bureau d\'ingénierie compétitif et performant, capable d\'apporter des solutions innovantes aux questions de développement des projets d\'infrastructures en République Démocratique du Congo.',
    
    // Services
    buildings: 'CONSTRUCTION\nMAISON',
    publicDevelopments: 'CONSTRUCTION\nIMMEUBLE',
    energyInfrastructure: 'INFRASTRUCTURES\nENERGETIQUES',
    renovation: 'RENOVATION',
    
    // About Section
    aboutTitle: 'A PROPOS DE',
    motto_label: 'Devise:',
    aboutMainTitle: 'Qu\u2019est-ce qu\u2019un constructeur d\u2019un b\u00e2timent ?',
    aboutIntroParagraph: 'Un constructeur b\u00e2timent est un professionnel sp\u00e9cialis\u00e9 dans la r\u00e9alisation des b\u00e2timents individuels et/ou professionnels. Les b\u00e2timents, traditionnelles, industrielles ou design, sont con\u00e7ues sur mesure pour r\u00e9pondre aux souhaits et s\u2019adapter aux attentes de chaque client.',
    aboutMissionsTitle: 'Les missions d\u2019un constructeur de maison',
    aboutMissionsParagraph1: 'En tant que constructeur des b\u00e2timents, notre r\u00f4le consiste \u00e0 guider nos clients \u00e0 chaque \u00e9tape du processus de construction, de la conception initiale \u00e0 la remise des cl\u00e9s. Selon vos besoins et votre budget, nous sommes \u00e9galement amen\u00e9s \u00e0 vous guider dans le choix et l\u2019achat du terrain \u00e0 b\u00e2tir, concevoir les plans du b\u00e2timent personnalis\u00e9, effectuer les d\u00e9marches li\u00e9es \u00e0 l\u2019obtention du permis de construire et fournir un accompagnement personnalis\u00e9 dans la compr\u00e9hension et ma\u00eetrise des r\u00e8gles d\u2019urbanisme.',
    aboutMissionsParagraph2: 'Une collaboration \u00e9troite avec nos clients est essentielle afin de comprendre les besoins, les attentes et les contraintes budg\u00e9taires, tout en tenant compte des normes de construction, de la r\u00e9glementation thermique, de la qualit\u00e9 des mat\u00e9riaux et de la durabilit\u00e9 de l\u2019habitat \u00e0 construire.',
    
    // Features
    feature1Title: 'Expérience acquise dans le développement et la gestion des partenariats public-privé',
    feature1Desc: 'Avec les routes concédées dans le cadre des plusieurs contrats de concessions.',
    feature2Title: 'Réalisation des études techniques des projets d\'infrastructures structurantes',
    feature2Desc: 'Grâce à un personnel multidisciplinaire et à des équipements modernes.',
    feature3Title: 'Contrôle et surveillance des travaux d\'infrastructures',
    feature3Desc: 'Plusieurs projets de travaux pilotés depuis la création suivant plusieurs modes de financement.',
    feature4Title: 'Diagnostic des ouvrages de génie civil',
    feature4Desc: 'Auscultation des chaussées aéronautiques et routières, des ouvrages d\'art et des bâtiments.',
    
    // News Section
    newsTitle: 'ACTUALITES',
    readMore: 'Lire plus',
    
    // Leadership
    leadershipTitle: 'La Direction Générale',
    directorGeneral: 'Directeur Gérant',
    deputyDirectorGeneral: 'Directeur Général Adjoint',
    
    // Stats
    statsTitle: 'Quelques chiffres',
    yearsExistence: 'Années d\'existence',
    agents: 'Agents',
    studyProjects: 'Projets d\'études',
    workProjects: 'Projets de travaux',
    
    // Map Section
    mapTitle: 'Directions Provinciales et Zones d\'interventions',
    
    // Newsletter
    newsletterTitle: 'Inscription à la newsletter',
    newsletterDesc: 'Abonnez-vous maintenant et recevez l\'actualité sur les activités de l\'entreprise, la publication des documents stratégiques, les appels d\'offre publiés et bien plus encore!',
    emailPlaceholder: 'Votre adresse email',
    subscribe: 'S\'INSCRIRE',
    subscribing: 'ENVOI...',
    subscribeSuccess: 'Vous avez été abonné avec succès!',
    subscribeError: 'Veuillez entrer votre adresse email',
    error: 'Erreur',
    success: 'Succès!',
    
    // Footer
    footerDesc: '',
    quickAccess: 'Accès rapide',
    usefulLinks: 'Liens utiles',
    contactUs: 'Contactez-nous',
    copyright: 'Copyright 2026 - Design by',
    
    // Quick Links
    aboutCompany: 'A propos de l\'entreprise',
    projects: 'Projets',
    tenders: 'Appels d\'offres',
    geomatics: 'Géomatique',
    
    // Useful Links
    presidency: 'Présidence de la République',
    primeMinistry: 'Primature',
    infrastructureMinistry: 'Ministère des Infrastructures et Travaux publics',
    anapi: 'Agence Nationale pour la Promotion des Investissements (ANAPI)',
    sicomines: 'Sino-Congolaise des Mines (SICOMINES)',
    
    // Hero Slider
    heroTitle1: 'Nous vous accompagnons à chaque étape de projet de construction votre bâtiment et restons à vos côtés pour assurer la bonne longévité de votre bâtiment.',
    heroTitle2: 'Nous vous accompagnons à chaque étape de projet de construction votre bâtiment et restons à vos côtés pour assurer la bonne longévité de votre bâtiment.',
    heroTitle3: 'Nous réalisons une étude énergétique pour adapter votre bâtiment au besoins de consommation.',
    heroTitle4: 'Nous réalisons une étude énergétique pour adapter votre bâtiment au besoins de consommation.',
    heroTitle5: 'Nous rénovons, réhabilitons et restaurons votre bâtiment.',
    
    // News Articles
    news1: 'Kinshasa : mise en service du premier tramway annoncée pour novembre 2027',
    news2: 'Kinshasa : l\'IGF inspecte l\'état d\'avancement des travaux dans le cadre du Programme d\'urgence',
    news3: 'Partenariat : Premier contact avec la société brésilienne Leve Construir Tecnologia',
    news4: 'Pont route-rail Kinshasa–Brazzaville : accord sur un régime fiscal commun',
    news5: 'Coopération bilatéral RDC-Zambie : nouvelle dynamique de coopération transfrontalière',
    news6: 'Route Kananga–Kalamba Mbuji : avancement satisfaisant des travaux',
    
    // Project Form
    talkAboutProject: 'Parlez nous de votre projet',
    getStarted: 'Je me lance !',
    backToHome: 'Retour à l\'accueil',
    projectFormTitle: 'Parlez-nous de votre projet',
    projectFormDesc: 'Remplissez ce formulaire pour que nous puissions mieux comprendre vos besoins et vous accompagner dans votre projet.',
    projectType_step: 'Type de projet',
    details_step: 'Détails',
    contact_step: 'Contact',
    whatProjectType: 'Quel type de projet souhaitez-vous réaliser ?',
    projectCategory: 'Catégorie du projet',
    projectDetails: 'Détails du projet',
    projectLocation: 'Localisation du projet',
    locationPlaceholder: 'Ville, Province, Région...',
    estimatedBudget: 'Budget estimé',
    desiredTimeline: 'Délai souhaité',
    projectDescription: 'Description du projet',
    descriptionPlaceholder: 'Décrivez votre projet en quelques lignes...',
    yourContactInfo: 'Vos coordonnées',
    fullName: 'Nom complet',
    company: 'Entreprise',
    email: 'Email',
    phone: 'Téléphone',
    next: 'Suivant',
    previous: 'Précédent',
    submitRequest: 'Envoyer ma demande',
    thankYou: 'Merci!',
    requestSubmitted: 'Votre demande a été envoyée avec succès. Nous vous contacterons bientôt.',
    fillRequired: 'Veuillez remplir tous les champs obligatoires',
    selectProjectType: 'Veuillez sélectionner un type de projet',
    privacyNotice: 'En soumettant ce formulaire, vous acceptez d\'être contacté par notre équipe concernant votre projet. Vos informations seront traitées de manière confidentielle.',
    
    // Project Categories
    feasibilityStudy: 'Étude de faisabilité',
    technicalDesign: 'Conception technique',
    construction: 'Construction',
    workSupervision: 'Supervision de travaux',
    maintenance: 'Maintenance',
    roadsStreets: 'Routes et voiries',
    
    // Budget Ranges
    lessThan100k: 'Moins de 100 000 $',
    from100kTo500k: '100 000 $ - 500 000 $',
    from500kTo1M: '500 000 $ - 1M $',
    moreThan1M: 'Plus de 1M $',
    
    // Timelines
    lessThan3Months: 'Moins de 3 mois',
    from3To6Months: '3-6 mois',
    from6To12Months: '6-12 mois',
    moreThan12Months: 'Plus de 12 mois',

    // Commitments (Nos engagements)
    commitmentsTitle: 'Nos engagements',
    commitmentListen: 'Écouter',
    commitmentPropose: 'Proposer',
    commitmentInnovate: 'Innover',
    commitmentQuote1: 'ÉCOUTER vos besoins, comprendre vos contraintes et vos attentes. Toute l\'équipe de GLOBAL CONSTRUCTION se rend disponible pour dialoguer avec vous et bâtir ensemble le projet qui vous ressemble.',
    commitmentQuote2: 'PROPOSER une solution parfaitement adaptée à vos besoins et à vos spécificités techniques. Vous bénéficiez d\'une étude de faisabilité sur mesure, menée par nos experts, pour donner vie à votre projet.',
    commitmentQuote3: 'INNOVER en intégrant des matériaux durables, des méthodes constructives modernes et une démarche éco-responsable, afin de livrer des bâtiments performants, fiables et tournés vers l\'avenir.',
    commitmentsLearnMore: 'En savoir +',

    // Home news teaser
    homeNewsTitle: 'Actualités',
    homeNewsReadMore: 'En savoir +',

    // Questions CTA
    questionsTitle: 'Vous avez des questions ?',
    questionsSubtitle: 'Nous sommes là pour vous conseiller',
    questionsContactBtn: 'Contactez-nous',
  },
  
  en: {
    // Header
    home: 'HOME',
    discoverTeam: 'DISCOVER GLOBAL CONSTRUCTION',
    aboutUs: 'ABOUT US',
    news: 'NEWS',
    yourProject: 'YOUR PROJECT',
    publications: 'PUBLICATIONS',

    // Top Bar
    topBarTagline: 'Construction & Engineering in the Democratic Republic of Congo',
    topBarContactExperts: 'Contact our experts',
    topBarJobs: 'Job offers',
    
    // Company Info
    companyName: 'GLOBAL CONSTRUCTION & ENGINEERING SARL',
    motto: '« Excellence is my law »',
    description: 'Public service of the DR Congo with the mission of designing and managing structural infrastructure projects in the sectors of Roads, Streets, Ports, Airports, Railways, Architecture, Energy, Passive telecommunications infrastructure and Environment.',
    ambition: 'Ambition to become a competitive and efficient large engineering firm, capable of providing innovative solutions to infrastructure project development issues in the Democratic Republic of Congo.',
    
    // Services
    buildings: 'HOUSE\nCONSTRUCTION',
    publicDevelopments: 'BUILDING\nCONSTRUCTION',
    energyInfrastructure: 'ENERGY\nINFRASTRUCTURE',
    renovation: 'RENOVATION',
    
    // About Section
    aboutTitle: 'ABOUT',
    motto_label: 'Motto:',
    aboutMainTitle: 'What is a building contractor?',
    aboutIntroParagraph: 'A building contractor is a professional specialized in constructing individual and/or commercial buildings. Traditional, industrial or designer buildings are custom-designed to meet each client\u2019s wishes and expectations.',
    aboutMissionsTitle: 'The missions of a building contractor',
    aboutMissionsParagraph1: 'As a building contractor, our role is to guide our clients through every step of the construction process, from the initial design to the handing over of the keys. Depending on your needs and budget, we also help you choose and buy building land, design the plans for your personalized building, handle the formalities for obtaining the building permit and provide personalized support in understanding and mastering urban-planning rules.',
    aboutMissionsParagraph2: 'Close collaboration with our clients is essential to understand their needs, expectations and budget constraints, while taking into account construction standards, thermal regulations, material quality and the sustainability of the home to be built.',
    
    // Features
    feature1Title: 'Experience acquired in the development and management of public-private partnerships',
    feature1Desc: 'With concessioned roads under several concession contracts.',
    feature2Title: 'Conducting technical studies of structural infrastructure projects',
    feature2Desc: 'Thanks to multidisciplinary staff and modern equipment.',
    feature3Title: 'Control and supervision of infrastructure works',
    feature3Desc: 'Several work projects managed since creation following various financing methods.',
    feature4Title: 'Diagnosis of civil engineering structures',
    feature4Desc: 'Inspection of aeronautical and road pavements, engineering structures and buildings.',
    
    // News Section
    newsTitle: 'NEWS',
    readMore: 'Read more',
    
    // Leadership
    leadershipTitle: 'General Management',
    directorGeneral: 'Managing Director',
    deputyDirectorGeneral: 'Deputy General Director',
    
    // Stats
    statsTitle: 'Some figures',
    yearsExistence: 'Years of existence',
    agents: 'Employees',
    studyProjects: 'Study projects',
    workProjects: 'Work projects',
    
    // Map Section
    mapTitle: 'Provincial Offices and Intervention Areas',
    
    // Newsletter
    newsletterTitle: 'Newsletter subscription',
    newsletterDesc: 'Subscribe now and receive news about company activities, publication of strategic documents, published tenders and much more!',
    emailPlaceholder: 'Your email address',
    subscribe: 'SUBSCRIBE',
    subscribing: 'SENDING...',
    subscribeSuccess: 'You have been successfully subscribed!',
    subscribeError: 'Please enter your email address',
    error: 'Error',
    success: 'Success!',
    
    // Footer
    footerDesc: '',
    quickAccess: 'Quick access',
    usefulLinks: 'Useful links',
    contactUs: 'Contact us',
    copyright: 'Copyright 2026 - Design by',
    
    // Quick Links
    aboutCompany: 'About the company',
    projects: 'Projects',
    tenders: 'Tenders',
    geomatics: 'Geomatics',
    
    // Useful Links
    presidency: 'Presidency of the Republic',
    primeMinistry: 'Prime Ministry',
    infrastructureMinistry: 'Ministry of Infrastructure and Public Works',
    anapi: 'National Agency for Investment Promotion (ANAPI)',
    sicomines: 'Sino-Congolese Mining Company (SICOMINES)',
    
    // Hero Slider
    heroTitle1: 'We support you at every stage of your building construction project and remain by your side to ensure the longevity of your building.',
    heroTitle2: 'We support you at every stage of your building construction project and remain by your side to ensure the longevity of your building.',
    heroTitle3: 'We conduct an energy study to adapt your building to consumption needs.',
    heroTitle4: 'We conduct an energy study to adapt your building to consumption needs.',
    heroTitle5: 'We renovate, rehabilitate and restore your building.',
    
    // News Articles
    news1: 'Kinshasa: first tram service announced for November 2027',
    news2: 'Kinshasa: IGF inspects progress of works under the Emergency Rehabilitation Program',
    news3: 'Partnership: First contact with Brazilian company Leve Construir Tecnologia',
    news4: 'Kinshasa–Brazzaville road-rail bridge: agreement on common tax regime',
    news5: 'DRC-Zambia bilateral cooperation: new dynamics of cross-border cooperation',
    news6: 'Kananga–Kalamba Mbuji Road: satisfactory progress of works',
    
    // Project Form
    talkAboutProject: 'Tell us about your project',
    getStarted: 'Get Started!',
    backToHome: 'Back to home',
    projectFormTitle: 'Tell us about your project',
    projectFormDesc: 'Fill out this form so we can better understand your needs and support you in your project.',
    projectType_step: 'Project Type',
    details_step: 'Details',
    contact_step: 'Contact',
    whatProjectType: 'What type of project do you want to carry out?',
    projectCategory: 'Project Category',
    projectDetails: 'Project Details',
    projectLocation: 'Project Location',
    locationPlaceholder: 'City, Province, Region...',
    estimatedBudget: 'Estimated Budget',
    desiredTimeline: 'Desired Timeline',
    projectDescription: 'Project Description',
    descriptionPlaceholder: 'Describe your project in a few lines...',
    yourContactInfo: 'Your Contact Information',
    fullName: 'Full Name',
    company: 'Company',
    email: 'Email',
    phone: 'Phone',
    next: 'Next',
    previous: 'Previous',
    submitRequest: 'Submit my request',
    thankYou: 'Thank you!',
    requestSubmitted: 'Your request has been submitted successfully. We will contact you soon.',
    fillRequired: 'Please fill in all required fields',
    selectProjectType: 'Please select a project type',
    privacyNotice: 'By submitting this form, you agree to be contacted by our team regarding your project. Your information will be treated confidentially.',
    
    // Project Categories
    feasibilityStudy: 'Feasibility Study',
    technicalDesign: 'Technical Design',
    construction: 'Construction',
    workSupervision: 'Works Supervision',
    maintenance: 'Maintenance',
    roadsStreets: 'Roads & Streets',
    
    // Budget Ranges
    lessThan100k: 'Less than $100,000',
    from100kTo500k: '$100,000 - $500,000',
    from500kTo1M: '$500,000 - $1M',
    moreThan1M: 'More than $1M',
    
    // Timelines
    lessThan3Months: 'Less than 3 months',
    from3To6Months: '3-6 months',
    from6To12Months: '6-12 months',
    moreThan12Months: 'More than 12 months',

    // Commitments (Our commitments)
    commitmentsTitle: 'Our commitments',
    commitmentListen: 'Listen',
    commitmentPropose: 'Propose',
    commitmentInnovate: 'Innovate',
    commitmentQuote1: 'LISTEN to your needs, understand your constraints and expectations. The entire GLOBAL CONSTRUCTION team is available to discuss with you and build together the project that looks like you.',
    commitmentQuote2: 'PROPOSE a solution perfectly tailored to your needs and technical specifications. You benefit from a custom feasibility study carried out by our experts, to bring your project to life.',
    commitmentQuote3: 'INNOVATE by integrating sustainable materials, modern construction methods and an eco-responsible approach, to deliver efficient, reliable and future-oriented buildings.',
    commitmentsLearnMore: 'Learn more +',

    // Home news teaser
    homeNewsTitle: 'News',
    homeNewsReadMore: 'Learn more +',

    // Questions CTA
    questionsTitle: 'Do you have questions?',
    questionsSubtitle: 'We are here to advise you',
    questionsContactBtn: 'Contact us',
  }
};

export const getTranslation = (language, key) => {
  return translations[language]?.[key] || translations['fr'][key] || key;
};